import { registerRootComponent } from "expo";

import logger from "./app/src/services/logger";
import App from "./AppContent";

logger.info("Inside App.ts");

registerRootComponent(App);
